import { CreatePatientComorbidityDTO } from './domain/models/PatientComorbidities'
import { MedicalSheetRepository } from './domain/repositories/MedicalSheetRepository'
import { medicalSheetDatasourceAdapter } from './external/datasources/medicalRecordDatasouceAdapter'
import { medicalSheetRepositoryAdapter } from './infra/repositories/MedicalRecordRepositoryAdapter'

export const medicalSheetInstance = MedicalSheet(
  medicalSheetRepositoryAdapter(medicalSheetDatasourceAdapter)
)

export function MedicalSheet(medicalSheetRepository: MedicalSheetRepository) {
  return {
    async getProfilePatientMedicalRecord(patientId: string) {
      return await medicalSheetRepository.getProfilePatientMedicalRecord(
        patientId
      )
    },
    async updateProfilePatientMedicalRecord(patientId: string, data) {
      return await medicalSheetRepository.updateProfilePatientMedicalRecord(
        patientId,
        data
      )
    },
    async getAllergyPatientMedicalRecord(patientId: string) {
      return await medicalSheetRepository.getAllergyPatientMedicalRecord(
        patientId
      )
    },
    async getFullPrescriptionMedicalRecord(patientId: string) {
      return await medicalSheetRepository.getFullPrescriptionMedicalRecord(
        patientId
      )
    },

    async deleteAllergyPatientMedicalRecord(patientAllergyId: string) {
      return await medicalSheetRepository.deleteAllergyPatientMedicalRecord(
        patientAllergyId
      )
    },
    async createAllergyPatientMedicalRecord(patientId, data) {
      return await medicalSheetRepository.createAllergyPatientMedicalRecord(
        patientId,
        data
      )
    },
    async remediesHomePatientMedicalRecord(patientId: string) {
      return await medicalSheetRepository.remediesHomePatientMedicalRecord(
        patientId
      )
    },
    async createRemediesHomePatientMedicalRecord(patientId, data) {
      return await medicalSheetRepository.createRemediesHomePatientMedicalRecord(
        patientId,
        data
      )
    },
    async drugAllergies(patientId: string) {
      return await medicalSheetRepository.drugAllergies(patientId)
    },
    async deleteDrugAllergies(allergyId: string) {
      return await medicalSheetRepository.deleteDrugAllergies(allergyId)
    },
    async deleteRemedieHome(remedyId: string) {
      return await medicalSheetRepository.deleteRemedieHome(remedyId)
    },
    async getPatientComorbidities(patientId: string) {
      return await medicalSheetRepository.getPatientComorbidities(patientId)
    },
    async createPatientComorbidity(
      patientId: string,
      data: CreatePatientComorbidityDTO
    ) {
      return await medicalSheetRepository.createPatientComorbidity(
        patientId,
        data
      )
    },
    async deletePatientComorbidity(comorbidityId: string) {
      return await medicalSheetRepository.deletePatientComorbidity(
        comorbidityId
      )
    }
  }
}
